import { stepPaymentStore } from '../store/stepPaymentStore'
import { container } from '../services/container'
import { Subscription } from '../core/Subscription'
import { errorStore } from '../store/errorStore'

export const stripeHelper = {
	data () {
		return {
      stripeConfig: stepPaymentStore.config.stripe,
      stripe: {
        error: null,
        complete: false
      },
      stripeLoading: true
		}
	},
	computed: {
	
	},
	mounted() {
	},
	methods: {
    initializeStripe() {
      this.stripeLoading = true;
      stepPaymentStore.createNewSetupIntent().then(response => {
        stepPaymentStore.config.stripe.client_secret = response.body.data.client_secret;

        this.stripe = Stripe(this.stripeConfig.options.key, {locale: 'it'});
        this.stripeConfig.options.clientSecret = stepPaymentStore.config.stripe.client_secret,

        stepPaymentStore.state.elements = this.stripe.elements(this.stripeConfig.options);
        this.cardElement = stepPaymentStore.state.elements.create('payment', {
          fields: {
            billingDetails: 'never'
          }
        });
        this.cardElement.mount('#payment-element');
        stepPaymentStore.state.stripe = this.stripe;
        this.stripeLoading = false;
      })
    },

    confirmStripeAndPaypal(refer) {

      console.log(refer)
      return container.get('services.oauth').authenticate().then(response => {
        var user = this.user
        user.subscription = new Subscription(response.body.data.resource.subscription)
        this.$root.updateUser(user)

        container.get('services.cookies').remove('_checkout_people')
        container.get('services.cookies').remove('_checkout_meals')

        if (container.get('source').getValue() == "order-now") {
          container.get('source').updateValue('default');
        }

        if (refer === 'prova-ora' || refer === 'check' || refer === "checkout") {
          this.$router.push({ name: 'thank-you-new' })
        }

        if (refer === 'profile') {
          this.$router.push({ name: 'profile_payment', params: { error: 'Modifiche applicate', state: 'success' } })
        }
      }).catch(response => {
        console.log(response)
        errorStore.formatMessage(response)
        if (response && response.body.errors) this.errorCode = response.body.errors[0].code
        this.errorOrderNowFrode = 'Non è possibile usufruire dell\'offerta poiché risulta già utilizzata con questo metodo di pagamento'
        if (refer === 'prova-ora') {
          this.$router.push({
            name: 'order-now', 
            params: { error: this.errorCode === 'FRAUD_COUPON_DUPLICATE'
              ? this.errorOrderNowFrode
              : errorStore.message
            }
          })
        }
        if (refer === 'check' || refer === 'checkout') {
          this.$router.push({ name: 'flow-new', params: { error: errorStore.message } })
        }
        if (refer === 'profile') {
          this.$router.push({ name: 'profile_payment', params: { error: errorStore.message, state: 'error' } })
        }
      })
    }
  }
		
}
